import React from 'react';

function ModalOption({ icon, title, description, id, handleSelection }) {
    const handleOptionSelection = () => {
        handleSelection(id);
    }
    
    return (
        <button onClick={handleOptionSelection} className='flex items-center gap-3 rounded-lg p-3 border border-[#EAEAEA]'>
            <div className="w-14 h-14 rounded-full bg-[#BCFCD7] flex items-center justify-center">
                <img src={icon} alt={title} />
            </div>

            <div className="text-left w-[calc(100%-56px)] flex flex-col font-urbanist-regular">
                <h1 className='font-semibold text-base text-[#121212]'>{title}</h1>

                <p className='font-medium text-[14px] leading-[22px] text-[#666666]'>{description}</p>
            </div>
        </button>
    );
}

export default ModalOption;
